// @flow
import GenericSlider from '@components/sliders/GenericSlider';

import { createGetOpts, config } from '@src/utils/sliders';

import type {
  LengthWidthRatioSearchFilterType,
  LengthWidthRatioSearchExtentType
} from '@types/search';
import type { OnSliderUpdateType } from '@components/containers/Diamonds';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as LengthWidthContent from '@components/popups/content/LengthToWidthRatio';

const optionsFunc = (values, extents, step, margin) => {
  // hide slider via ErrorBoundary
  if (extents[0] === extents[1]) throw new Error("min and max can't be equal");

  return {
    start: values,
    range: {
      min: extents[0],
      max: extents[1]
    },
    step: step,
    margin: margin,
    connect: [false, true, false]
  };
};

type PropsType = {
  onSliderUpdate: OnSliderUpdateType,
  value: LengthWidthRatioSearchFilterType | void,
  extent: LengthWidthRatioSearchExtentType,
  disableTabIndex?: boolean
};

const Popup = () => <QuestionMarkPopup initialContent={LengthWidthContent} />;

export default class LengthWidthSlider extends React.Component<PropsType> {
  render() {
    const { value, extent } = this.props;
    const getOpts = createGetOpts(extent, optionsFunc, config.lw_ratio);

    return (
      <GenericSlider
        title={'Length/Width'}
        getOpts={getOpts}
        value={value || extent}
        userValue={value}
        extent={extent}
        onSliderUpdate={values =>
          this.props.onSliderUpdate(
            'UPDATE_LENGTH_WIDTH_RATIO',
            values.map(Number)
          )
        }
        Popup={Popup}
        inputWidth={'48px'}
        inputType='text'
        inputStep={config.lw_ratio.stepSize}
        inputStepMargin={config.lw_ratio.margin}
        disableTabIndex={this.props.disableTabIndex}
        inputs
      />
    );
  }
}
